// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal[data-v-bc1e7658] {\n  white-space: normal;\n}\n.modal button.close[data-v-bc1e7658] {\n  position: absolute;\n  top: 0.2em;\n  right: 0.5em;\n  font-size: 1.8em;\n}\n.modal .container[data-v-bc1e7658] {\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n}\n", ""]);
// Exports
module.exports = exports;
